const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#3475B2',
                hover: '#2566A3'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
